import type { DreamRenderElementProps } from '@/types';

interface Props {
  referralLink: string;
  referralCount: number;
  onClickCopy?: (link: string) => void;
  translations?: DreamRenderElementProps<any>['translations'];
}

const Overview = ({ referralLink, referralCount, onClickCopy, translations }: Props) => {
  return (
    <div className="flex w-full flex-col gap-6 sm:flex-row p-4 border border-gray-200 rounded-md bg-[#F9FAFB]">
      <div className="w-full sm:w-1/2 rounded-md border border-gray-200 overflow-hidden">
        <div
          className="w-full p-4"
          style={{
            background: 'var(--pt-background-color)',
          }}
        >
          <div
            className="text-base font-semibold leading-6"
            style={{
              color: 'var(--pt-text-on-background-color)',
            }}
          >
            {translations?.['referrals.share.count']}
          </div>
        </div>
        <div className="flex items-center justify-center py-4 text-2xl font-semibold bg-white text-gray-900 leading-9">
          {referralCount}
        </div>
      </div>
      <div className="w-full sm:w-1/2 flex flex-col gap-2">
        <h5 className="text-sm text-gray-900 font-medium leading-5">{translations?.['referrals.share.link_title']}</h5>
        <div className="flex h-[36px] w-full shadow-sm rounded-md overflow-hidden">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="block h-full w-full rounded-l-md border border-r-0 border-gray-200 text-sm font-normal leading-5 text-gray-900 outline-0 focus:text-sm"
            placeholder={translations?.['subscribe.email_placeholder'] || ''}
            required
          />
          <button
            onClick={() => onClickCopy?.(referralLink)}
            type="button"
            className="h-full w-fit cursor-pointer rounded-sm rounded-r-md border border-[#C7D2FE] bg-[#EEF2FF] py-2 px-3 text-sm text-[#4338CA]"
          >
            {translations?.['shared.cta.copy']}
          </button>
        </div>
        <p className="text-xs leading-4 font-light text-gray-900">{translations?.['referrals.share.link_help_text']}</p>
      </div>
    </div>
  );
};

export default Overview;
